import { queryClient } from "@/queryClient";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/edge-gateways/$id")({
  staticData: {
    title: "edge.navigation.edgeGateways",
  },
  loader: async () => {
    const { queries } = await import("@/modules/sources/edge-gateways/services/queries");
    return queryClient.ensureQueryData(queries.getGateways());
  },
});
